import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "kt_sidebar_content",
  class: "py-10 px-7 px-lg-12"
}
const _hoisted_2 = {
  class: "hover-scroll-y me-lg-n7 pe-lg-5",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-offset": "10px",
  "data-kt-scroll-wrappers": "#kt_sidebar_content"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column text-center mb-10" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fs-2 fw-bolder mb-2" }, "Novo Produto"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-6 fw-bolder" }, "Adicione de forma rápida em seu estoque")
], -1)
const _hoisted_4 = { class: "d-flex mb-8 justify-content-between" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-70px me-4 bg-light" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "symbol-label",
    style: {"background-image":"url('media/products/11.png')"}
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-70px me-4" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "symbol-label",
    style: {"background-image":"url('media/products/12.png')"}
  })
], -1)
const _hoisted_7 = { class: "symbol symbol-70px" }
const _hoisted_8 = {
  href: "#",
  class: "h-70px w-70px btn btn-light d-flex flex-column flex-center fw-bolder p-0"
}
const _hoisted_9 = { class: "svg-icon svg-icon-1 svg-icon-gray-600 m-0" }
const _hoisted_10 = { class: "mt-5" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"mb-4 fw-bolder fs-6\">Detalhes sobre seu produto</div><div class=\"mb-8\"><label class=\"fw-bolder\">Nome</label><input type=\"text\" class=\"form-control form-control-solid form-control-lg\" placeholder=\"\"></div><div class=\"mb-8\"><label class=\"fw-bolder\">Categorias</label><select class=\"form-select form-select-solid form-select-lg\" data-control=\"select2\" data-placeholder=\"Select Category...\" data-hide-search=\"true\"><option value=\"mens\">Mens</option><option value=\"womens\">Womens</option><option value=\"accessories\">Accessories</option><option value=\"technology\">Technology</option><option value=\"appliances\">Appliances</option></select></div><div class=\"mb-8\"><label class=\"fw-bolder\">Tamanhos</label><select class=\"form-select form-select-solid form-select-lg\" data-control=\"select2\" data-placeholder=\"Select Size...\" data-hide-search=\"true\"><option value=\"xs\">XS</option><option value=\"s\">S</option><option value=\"m\" selected>M</option><option value=\"l\">L</option><option value=\"xl\">XL</option></select></div><div class=\"mb-8\"><label class=\"fw-bolder\">Descrição</label><textarea class=\"form-control form-control-solid form-control-lg\" rows=\"3\"></textarea></div><div class=\"mb-8\"><label class=\"fw-bolder\">Preço</label><input type=\"text\" class=\"form-control form-control-solid form-control-lg\" placeholder=\"\"></div><button type=\"submit\" class=\"btn btn-primary fw-bolder me-2 px-8\"> Adicionar </button>", 7)
const _hoisted_18 = { class: "d-flex flex-column text-center bg-light rounded py-8 px-5 mb-10" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h3", { class: "fs-2 fw-bolder mb-2" }, "Novo Produto", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-6 fw-bolder" }, "Adicione de forma rápida em seu estoque.", -1)
const _hoisted_21 = { class: "form" }
const _hoisted_22 = { class: "mb-11" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "fs-2 fw-bolder text-dark mb-7" }, "Categorias", -1)
const _hoisted_24 = ["value"]
const _hoisted_25 = {
  class: "form-check-label fw-bold text-gray-600",
  for: "kt_checkbox_1"
}
const _hoisted_26 = {
  key: 0,
  class: "mb-13"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "text-dark fw-bolder fs-6 mb-5" }, "Pricing Range", -1)
const _hoisted_28 = {
  id: "kt_price_slider",
  ref: "sliderRef",
  class: "nouislider nouislider-light nouislider-handle-primary nouislider-bg-dark-15 nouislider-shadowless nouislider-borderless"
}
const _hoisted_29 = { class: "mb-11" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "fs-2 fw-bolder text-dark mb-7" }, "Tamanhos", -1)
const _hoisted_31 = {
  class: "d-flex",
  role: "group"
}
const _hoisted_32 = ["onUpdate:modelValue"]
const _hoisted_33 = {
  class: "btn btn-active-primary btn-lg btn-icon btn-light btn-active-primary fw-bold h-35px w-35px mx-1",
  for: "kt_size_1"
}
const _hoisted_34 = {
  key: 1,
  type: "reset",
  class: "btn btn-primary fw-bolder me-2 px-8"
}
const _hoisted_35 = {
  key: 2,
  class: "btn btn-color-gray-600 btn-active-light-primary fw-bolder px-8"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass({ 'd-none': _ctx.displayFilterForm }),
        id: "kt_sidebar_shop_new_form"
      }, [
        _hoisted_3,
        _createElementVNode("form", {
          class: "form",
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.newProductFormSubmit && _ctx.newProductFormSubmit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("a", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen006.svg" })
                ]),
                _createTextVNode(" Incluir ")
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("button", {
              type: "reset",
              id: "kt_sidebar_shop_filter_form_btn",
              class: "btn btn-color-gray-600 btn-active-light-primary fw-bolder px-8",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showProductFilterForm && _ctx.showProductFilterForm(...args)))
            }, " Cancelar ")
          ])
        ], 32)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass({ 'd-none': !_ctx.displayFilterForm }),
        id: "kt_sidebar_shop_filter_form"
      }, [
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _hoisted_20,
          _createElementVNode("button", {
            id: "kt_sidebar_shop_new_form_btn",
            class: "btn btn-primary fw-bolder mx-auto px-5 mt-6",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showProductAddForm && _ctx.showProductAddForm(...args)))
          }, " Começar ")
        ]),
        _createElementVNode("form", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCategories, (category) => {
              return (_openBlock(), _createElementBlock("div", {
                key: category.value,
                class: "form-check form-check-custom form-check-solid mb-5"
              }, [
                _createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: "kt_checkbox_1",
                  value: category.value
                }, null, 8, _hoisted_24),
                _createElementVNode("label", _hoisted_25, _toDisplayString(category.label), 1)
              ]))
            }), 128))
          ]),
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, null, 512)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSizes, (size) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: size.value
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    class: "btn-check",
                    name: "sizes",
                    "onUpdate:modelValue": ($event: any) => ((size.value) = $event),
                    id: "kt_size_1"
                  }, null, 8, _hoisted_32), [
                    [_vModelRadio, size.value]
                  ]),
                  _createElementVNode("label", _hoisted_33, _toDisplayString(size.label), 1)
                ], 64))
              }), 128))
            ])
          ]),
          false
            ? (_openBlock(), _createElementBlock("button", _hoisted_34, " Resetar "))
            : _createCommentVNode("", true),
          false
            ? (_openBlock(), _createElementBlock("button", _hoisted_35, " Configurar "))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ])
  ]))
}